<template>
  <div class="d-flex flex-column justify-content-center align-items-center">
    <h1>
        404
    </h1>
    <h2>
        ❌ something went wrong ❌
    </h2>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    h1 {
        font-size: 350px;
    }
    h2 {
        font-size: 72px;
    }
</style>